import config from '../config/index'
import {
  IPaginatedStudio,
  IPaginatedStudioFilterParams,
  IStudio,
  INearbyCorporatesResponse,
} from '../pages/studios-container/share-type'
import { authRequest } from '../request'
import qs from 'qs'

const { mainApi } = config

export const getStudiosSuggestion = (keyword: string) =>
  authRequest.get<MISSING_TYPE, { id: number; name: string; cityId: number }[]>(
    `${mainApi}/studios/suggestions?keyword=${keyword}`,
  )

export const getStudiosSuggestionsByIds = (ids: number[]) =>
  authRequest.get<MISSING_TYPE, { id: number; name: string }[]>(
    `${mainApi}/studios/suggestions-by-ids`,
    {
      params: {
        ids,
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
    },
  )

export const getStudios = (params: IPaginatedStudioFilterParams) => {
  return authRequest.get<MISSING_TYPE, IPaginatedStudio>(`${mainApi}/studios`, {
    params,
  })
}

export const getStudioDetail = (id: number) => {
  return authRequest.get<MISSING_TYPE, IStudio>(`${mainApi}/studios/${id}`)
}

export const getNearbyCorporates = (studioId: number, distanceKm: number) =>
  authRequest.get<MISSING_TYPE, INearbyCorporatesResponse>(
    `${mainApi}/studios/${studioId}/nearby-corporates`,
    { params: { distanceKm } },
  )
